/**
 * A file to nicely wrap various document and app lifecycle events into observables
 */

import {Observable} from 'rxjs';

export const documentResumeObservable = Observable.create(observer => {
    document.addEventListener(
        'resume',
        (...args) => {
            observer.next(...args);
        },
        false,
    );
});
